import React from "react";
import { Button, Tooltip } from "@mantine/core";
import { Link, useLocation } from "react-router-dom";
import { BsBellFill } from "react-icons/bs";
import { useGetMultiplacerReleaseNotesStatusQuery } from "../../../openapi";

export const ReleaseNotesNavButton: React.FC = () => {
  const location = useLocation();
  const { data } = useGetMultiplacerReleaseNotesStatusQuery();

  const hasUnread = Boolean(data?.hasUnread);

  const bellColor = hasUnread ? "#ff6b6b" : undefined;

  return (
    <>
      <style>
        {`
          @keyframes bellRing {
            0%   { transform: rotate(0deg); }
            2%   { transform: rotate(12deg); }
            4%   { transform: rotate(-12deg); }
            6%   { transform: rotate(10deg); }
            8%   { transform: rotate(-10deg); }
            10%  { transform: rotate(8deg); }
            12%  { transform: rotate(-8deg); }
            14%  { transform: rotate(6deg); }
            16%  { transform: rotate(-6deg); }
            18%  { transform: rotate(0deg); }
            100% { transform: rotate(0deg); }
          }

          @media (prefers-reduced-motion: reduce) {
            .mp-bell-ring {
              animation: none !important;
            }
          }
        `}
      </style>

      <Tooltip label={hasUnread ? "Nye release-notater" : "Release-notater"} withArrow>
        <Button
          leftSection={
            <span
              className={hasUnread ? "mp-bell-ring" : undefined}
              style={{
                display: "inline-flex",
                transformOrigin: "50% 10%",
                animation: hasUnread ? "bellRing 1.8s ease-in-out infinite" : undefined,
                color: bellColor, // ✅ helrød (lys rød)
              }}
            >
              <BsBellFill size={18} />
            </span>
          }
          data-current-page={location.pathname === "/releasenotes"}
          to="/releasenotes"
          component={Link}
          variant="header"
          style={{ cursor: "pointer" }}
        >
          Release-notater
        </Button>
      </Tooltip>
    </>
  );
};
